export const ANALYTICS_ENABLED = true
export const GOOGLE_ANALYTICS_KEY = "G-HR3PWMHKQQ"
// END-ANALYTICS-ENVS
